/**
 * @generated SignedSource<<65d8b2711ac32b4b4b6bc35baa020e47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateRecruitOTPInput = {
  clientMutationId?: string | null;
  recruitId: string;
};
export type ProjectScreenerPage_CreateRecruitOtp_Mutation$variables = {
  input: CreateRecruitOTPInput;
};
export type ProjectScreenerPage_CreateRecruitOtp_Mutation$data = {
  readonly createRecruitOtp: {
    readonly id: string;
    readonly value: string;
  } | null;
};
export type ProjectScreenerPage_CreateRecruitOtp_Mutation = {
  response: ProjectScreenerPage_CreateRecruitOtp_Mutation$data;
  variables: ProjectScreenerPage_CreateRecruitOtp_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateRecruitOTPPayload",
    "kind": "LinkedField",
    "name": "createRecruitOtp",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectScreenerPage_CreateRecruitOtp_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectScreenerPage_CreateRecruitOtp_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "168d3bd6e0360b9514694f88d807d05d",
    "id": null,
    "metadata": {},
    "name": "ProjectScreenerPage_CreateRecruitOtp_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProjectScreenerPage_CreateRecruitOtp_Mutation(\n  $input: CreateRecruitOTPInput!\n) {\n  createRecruitOtp(input: $input) {\n    id\n    value\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac1c218f3b3ec774e20519a4931ae08b";

export default node;
